import React from 'react'
import { WhenTheme } from 'widgets/theme-switcher'
import StaffList from 'widgets/shifts/themes/staff/StaffList'

export default function ScheduleStaffListTheme () {
  return (
    <WhenTheme type='staff'>
      <StaffList />
    </WhenTheme>
  )
}
